import React from 'react';
import { Navigate, useLocation } from 'react-router';

import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';
import { EnforceMfaContent } from '@/shared/features/rbac/components/enforce-mfa-warning/enforce-mfa-content';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const user = useAppSelector(selectUser);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // The preference is read after the user; until it lands neither branch below is right.
  if (user.mfaEnabled === undefined) {
    return <FullscreenLoader />;
  }

  return (
    <>
      {user.mfaEnabled && children}
      <EnforceMfaContent display={!user.mfaEnabled} />
    </>
  );
};
